/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type ColumnGridDataType = (typeof ColumnGridDataType)[keyof typeof ColumnGridDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ColumnGridDataType = {
    Numeric: 'Numeric',
    Alphanumeric: 'Alphanumeric',
} as const;
